import React from 'react';

import GuaranteeComponent from '../components/app/Guarantee/Guarantee';

const Guarantee = (props) => {
  return (
    <GuaranteeComponent {...props} />
  );
};

export default Guarantee;
